/**
 * Check-in Entry Point
 * Handles deep-link navigation with businessId/menuItemId params.
 * Direct navigation (e.g., from tab bar) is handled by the DraftSelectorModal
 * in the tab layout, bypassing this screen entirely.
 */

import { router, useLocalSearchParams } from 'expo-router';
import React, { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useAppTheme } from '@/providers/theme-provider';

export default function CheckInEntryScreen() {
  const theme = useAppTheme();
  const { businessId, menuItemId } = useLocalSearchParams<{
    businessId?: string;
    menuItemId?: string;
  }>();

  useEffect(() => {
    // Redirect to quick check-in, passing through any deep-link params
    if (businessId) {
      router.replace({
        pathname: '/(root)/check-in/quick',
        params: { businessId, menuItemId },
      });
    } else {
      // No deep-link params - redirect directly to quick check-in
      router.replace('/(root)/check-in/quick');
    }
  }, [businessId, menuItemId]);

  // Show loading while redirecting
  return (
    <View className="flex-1 bg-background justify-center items-center">
      <ActivityIndicator size="large" color={theme.colors.primary} />
    </View>
  );
}
